/** The contract every block renderer implements. */

import type { AttemptRecord, BlockView, SessionView } from "../types.ts";

export interface DeferredAnswer {
	id: string;
	block_id: number;
	text: string;
}

export interface BlockResult {
	attempts: AttemptRecord[];
	/** Test sessions hold free text until submission — no correction mid-test. */
	deferred?: DeferredAnswer;
}

export interface BlockContext {
	session: SessionView;
	block: BlockView;
	englishRatio: number;
	isTest: boolean;
	online: boolean;
	/** Advances to the next block. */
	finish: (result: BlockResult) => void;
	/** Replaces the footer action, e.g. Check answer -> Continue. */
	setFooter: (node: Node | null) => void;
}

export interface RenderedBlock {
	body: Node[];
	footer: Node | null;
}

export function uuid(): string {
	return crypto.randomUUID();
}
